import React, { useRef } from 'react';
import { deleteOffboadingTemplateData, getOffboadingTemplateData } from '../../service/adminApi';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import SideNavBar from '../../components/SideNavBar/SideNavBar';
import { getTimestampToDate } from '../../utils/dateConvetor';
import { useNavigate } from 'react-router-dom';
import Popup from '../../components/ConformationPopup/Popup';

function OffboardingTemplates() {
    let breadcrumbData = [
        { title: 'Dashboard', path: '/Overview', isActive: true },
        { title: 'Admin', path: '/admin/accountbranding', isActive: true },
        { title: 'Offboarding', path: '', isActive: false },
    ];

    const navigate = useNavigate();
    const [offboardingTemplateList, setOffboardingTemplateList] = React.useState([]);
    const [editOffboardingTemplateData, setEditOffboardingTemplateData] = React.useState();
    const [flag, setFlag] = React.useState(false);
    const [deleteIndex, setDeleteIndex] = React.useState();
    const [hideContainer, setHideContainer] = React.useState(true);

    React.useEffect(() => {
        getOffboardingTemplate();
    }, []);

    const getOffboardingTemplate = async () => {
        const response = await getOffboadingTemplateData();

        if (response.data.statusCode === 200) {
            setOffboardingTemplateList(response.data.data);
        }
    };

    const deleteTemplateData = async () => {
        let index = deleteIndex;
        let data = {
            id: offboardingTemplateList[index].id,
            is_active: false,
        };
        const response = await deleteOffboadingTemplateData(data);
        if (response.data.statusCode === 200) {
            let array = offboardingTemplateList;
            let arr = array.splice(index, 1);
            let updatedData = array;
            setOffboardingTemplateList(updatedData);
            setFlag(!flag);
        }
    };

    const updateOffbordingDetails = (data) => {

        switch (data) {
            case 'cancel':
                setEditOffboardingTemplateData({});
                break;
            case 'update':
                getOffboardingTemplate();
                setEditOffboardingTemplateData({});
                break;
            default:
                break;
        }
    };

    const navigateTemplateTask = (taskId) => {
        navigate('/admin/offboarding/' + taskId);
    };

    return (
        <div className="col-md-10 offset-md-2 content-card">
            <BreadCrumbs data={breadcrumbData} />
            {hideContainer == false ? <SideNavBar
                form="offboardingTemplate"
                editData={editOffboardingTemplateData}
                handleData={(data) => {
                    updateOffbordingDetails(data);
                }}
                hideContainer={hideContainer}
                setHideContainer={() => setHideContainer()}
            /> : null}
            <div className="row">
                <div className="col-md-12 mb-3">
                    <div className="d-flex justify-content-between">
                        <h5 className="bold-text tt-bold font-18">Offboarding</h5>
                        <a
                            className="btn hive-btn-primary"
                            type="button"
                            // data-bs-toggle="offcanvas"
                            // data-bs-target="#offcanvasRight"
                            // aria-controls="offcanvasRight"
                            onClick={() => setHideContainer(false)}
                        >
                            <img className="me-2" src="/Images/plus.svg" />
                            New Template
                        </a>
                    </div>
                </div>
                {offboardingTemplateList.map((data, index) => {
                    let joinDate = getTimestampToDate(data.modified_at, 3);
                    return (
                        <div className="col-md-3 mb-3">
                            <div className="card admin-card-styles border-0 ">
                                <div
                                    className="admin-offboard-bg-holder admin-offboard-bg-card admin-offboard-bg-image"
                                    style={{
                                        backgroundImage: 'url(/Images/card-bg.svg)',
                                    }}
                                />
                                {/*/.bg-holder*/}
                                <div
                                    onClick={() => {
                                        navigateTemplateTask(data.id);
                                    }}
                                    className="card-body position-relative mt-3"
                                >
                                    <h6 className="bold-text font-12 mb-4">{data.name}</h6>
                                    <p className="regular-text font-12 mb-1">{data.description}</p>
                                    <p className="medium-text font-10 admin-offboard-dateupdate">Last Updated : {joinDate}</p>
                                </div>
                                <div class="card-kebab-position">
                                    <img
                                        src="/Images/card_edit.svg"
                                        alt="Icon"
                                        class="m-1"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    />
                                    <ul className="dropdown-menu dropdown-menu-end offboarding-card-dropdown border-0 shadow-sm">
                                        <li>
                                            <a
                                                className="dropdown-item dditems border-bottom semibold-text font-12 touchbase-kebabitems-color"
                                                type="button"
                                                data-bs-toggle="offcanvas"
                                                x
                                                data-bs-target="#offcanvasRight"
                                                aria-controls="offcanvasRight"
                                                onClick={() => {
                                                    setEditOffboardingTemplateData(offboardingTemplateList[index]);
                                                    setHideContainer(false);
                                                }}
                                            >
                                                Edit
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="dropdown-item dditems semibold-text font-12 touchbase-kebabitems-color"
                                                data-bs-toggle="modal"
                                                data-bs-target="#logout"
                                                onClick={() => {
                                                    setDeleteIndex(index);
                                                }}
                                            >
                                                Delete
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <Popup
                                deleteData={() => {
                                    deleteTemplateData();
                                }}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default OffboardingTemplates;
